import { API_BASE_URL, API_FETCH_EXAM_UUID } from '../../consts';
import axios from "axios";
import refreshAccessToken from './refreshAccessToken';


export interface ExamUUIDObject {
    uuid: string; // UUID of the object
    end_at: string; // ISO date string representing the end date
}


async function executeFetchUUDsWithToken(accessToken: string | null): Promise<ExamUUIDObject[]> {
    return axios
        .get(
            API_BASE_URL + API_FETCH_EXAM_UUID,
            {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
            }
        )
        .then(response => {
            if (response.status === 200) {
                return Promise.resolve(response.data);
            }
        })
        .catch(error => {
            if (error.response && error.response.status === 401) {
                console.log("not authenticated");
            } else if (error.response && error.response.status === 404) {
                console.log("exam UUID not found or AppUser not found");
            } else {
                console.error('Error during fetching:', error);
            }
            return Promise.reject(error);
        });
}


export default async function autoRefreshedExecuteFetchUUDsWithToken(accessToken: string | null): Promise<ExamUUIDObject[]> {

    return executeFetchUUDsWithToken(accessToken)
        .catch(error => {
            if (error.response.status == 401) {
                return refreshAccessToken().then(refreshedAccessToken => {
                    if (refreshedAccessToken) {
                        console.log("refreshed");
                        return executeFetchUUDsWithToken(accessToken);
                    } else {
                        throw error;
                    }
                });
            }
            throw error;
        });
}
